import { Component, OnInit } from '@angular/core';

import { DetailsService } from '../../services/details.service';
import { InventoryService } from '../../services/inventory.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { IFoodType, IFoodSize, IFeedingLineItemDetail, IFeedingOutcome, IInventoryMasterDetail,
		 IGrowthLineItemDetail, IShedLineItemDetail, IFecalLineItemDetail, IHealthLineItemDetail,
		 IShedType, IHealthIncidentType, IFecalAppearance, IInventoryType, IDetailLineItem } from '../../interfaces';

import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'view-inventory',
  templateUrl: './view-inventory.component.html',
  styleUrls: ['./view-inventory.component.css']
})
export class ViewInventoryComponent implements OnInit {

	feedingLineItemDetails: IFeedingLineItemDetail[] = [];
	shedLineItemDetails: IShedLineItemDetail[] = [];
	growthLineItemDetails: IGrowthLineItemDetail[] = [];
	defecationLineItemDetails: IFecalLineItemDetail[] = [];
	healthLineItemDetails: IHealthLineItemDetail[] = [];
	foodSizes: IFoodSize[] = [];
	foodTypes: IFoodType[] = [];
	shedTypes: IShedType[] = [];
	fecalAppearances: IFecalAppearance[] = [];
	incidentTypes: IHealthIncidentType[] = [];
	outcomeList: IFeedingOutcome[] = [];
	masterRecords: IInventoryMasterDetail[] = [];
	selectedMasterRecord: IInventoryMasterDetail;
	selectedRecord: number = 0;
	displayList: string = '';
	groupId: number = 0;
	inventoryTypes: IInventoryType[] = [];
	feedColumns: string[] = [];

	selectedRecordNameId: string = "";
	selectedInventoryType: IInventoryType;
	imagePath: any;

	listFeedDetail: any[];
	listShedDetail: any[];
	listGrowthDetail: any[];
	listHealthDetail: any[];
	listFecalDetail: any[];

	isAuthenticated: boolean = false;

	constructor(private detailsService: DetailsService, private router: Router, 
				private route: ActivatedRoute, private inventoryService: InventoryService,
				private _sanitizer: DomSanitizer) { }

	ngOnInit() {
		if(sessionStorage.getItem("token")){
	        let obj = JSON.parse(sessionStorage.getItem("token"));
	        if(obj && obj.Token != ""){
	          this.isAuthenticated = true;
	        }
	    }
	    else {
	      this.router.navigate(['/login']);
	    }
	    
	    if(sessionStorage.getItem("groupId")){
	      let group = JSON.parse(sessionStorage.getItem("groupId"));
	      if(group && group.GroupId != 0){
	          this.groupId = group.GroupId;
	      }
	    }

	    this.inventoryService.getInventoryTypes().subscribe(
	    	invTypes => {
	    		this.inventoryTypes = invTypes;
		    this.detailsService.getMasterDetailRecords(this.groupId).subscribe(
	  		records => {
	  			this.selectedRecord = parseInt(this.route.snapshot.paramMap.get('id'));	    
	  			this.masterRecords = records;
	  			this.selectedMasterRecord =  this.masterRecords.find(record => record.Id == this.selectedRecord);

		        if(this.selectedMasterRecord.Avatar && this.selectedMasterRecord.Avatar != ''){
		          this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' 
		                   + this.selectedMasterRecord.Avatar);
		        }
	  			this.selectedInventoryType = this.inventoryTypes.find(type => this.selectedMasterRecord.InventoryTypeId == type.Id);
	  			this.detailsService.getFoodSizes().subscribe(
		  			sizes => {
		  			this.foodSizes = sizes;
		  			this.detailsService.getFeedingOutcomes().subscribe(
			  			outcomes => {
			  			this.outcomeList = outcomes;
			  			this.detailsService.getFoodTypes().subscribe(
				  			foodTypes => {
				  			this.foodTypes = foodTypes;
				  			this.getFeedRecords();
						});
					});
				});
				this.detailsService.getShedTypes().subscribe(
		  			shedTypes => {
		  			this.shedTypes = shedTypes;
		  			this.getShedRecords();
				});

				this.detailsService.getHealthIncidentTypes().subscribe(
		  			incidentTypes => {
		  			this.incidentTypes = incidentTypes;
		  			this.getHealthRecords();
				});

				this.getGrowthRecords();
				
				this.detailsService.getDefecationAppearances().subscribe(
		  			appearances => {
		  			this.fecalAppearances = appearances;
		  			this.getDefecationRecords();
				});
	  		});	
  		});
	}

	loadFeedingDetailList(allDetails: IDetailLineItem[]){
		this.listFeedDetail = [];
		
		if(this.feedingLineItemDetails.length >0){
			this.feedingLineItemDetails.forEach(detail => {
				let type = this.foodTypes.find(types => {return types.Id == detail.FoodTypeId});
				let size = this.foodSizes.find(sizes => {return sizes.Id == detail.FoodSizeId});
				let outcome = this.outcomeList.find(outcome => { return outcome.Id == detail.Outcome });
				let detailDate = allDetails.find( d => { return d.Id == detail.DetailLineItemId });
				this.listFeedDetail.push({
					Id: detail.Id, 
					FeedType: type.Name, 
					FeedSize: size.Name, 
					Quantity: detail.Quantity, 
					Outcome: outcome.DisplayName,
					AdditionalNotes: detail.AdditionalNotes,
					LineItemDate: detailDate.LineItemDate
				});
			});
		}
		this.displayList = 'Feed';
	}

	loadShedDetailList(){
		this.listShedDetail = [];
		if(this.shedLineItemDetails.length > 0){
			this.shedLineItemDetails.forEach(detail => {
				let type = this.shedTypes.find(types => { return types.Id == detail.ShedType });
				this.listShedDetail.push({
					Id: detail.Id, 
					Display: type.DisplayName,
					AdditionalNotes: detail.AdditionalNotes,
					SoakRequired: detail.SoakRequired
				});
			});
		}
		this.displayList = 'Shed';
	}

	loadGrowthDetailList(){
		this.listGrowthDetail = [];
		if(this.growthLineItemDetails.length > 0){
			this.growthLineItemDetails.forEach(detail => {
				this.listGrowthDetail.push({
					Id: detail.Id, 
					Weight: detail.Weight,
					Lenght: detail.Length,
					AdditionalNotes: detail.AdditionalNotes
				});
			});
		}
		this.displayList = 'Growth';
	}

	loadHealthDetailList(){
		this.listHealthDetail = [];
		if(this.healthLineItemDetails.length > 0){		
			this.healthLineItemDetails.forEach(detail => {
				let type = this.incidentTypes.find(types => { return types.Id == detail.IncidentType });
				this.listHealthDetail.push({
					Id: detail.Id, 
					IncidentType: type.DisplayName,
					IncidentResultNotes: detail.IncidentResultNotes,
					Medication: detail.Medication,
					MedicationDose: detail.MedicationDose,
					AdditionalNotes: detail.AdditionalNotes
				});
			});
		}
		this.displayList = 'Health';
	}

	loadDefecationDetailList(){
		this.listFecalDetail = [];
		if(this.defecationLineItemDetails.length > 0){		
			this.defecationLineItemDetails.forEach(detail => {
				let appearance = this.fecalAppearances.find(types => { return types.Id == detail.Appearance });
				this.listFecalDetail.push({
					Id: detail.Id, 
					Appearance: appearance.DisplayName,
					AdditionalNotes: detail.AdditionalNotes
				});
			});
		}
		this.displayList = 'Defecation';
	}

	getFeedRecords(){
		if(this.selectedRecord != 0){
			let masterRecord = this.masterRecords.find(record => record.Id == this.selectedRecord);

			this.detailsService.getDetailLineItems(this.selectedRecord).subscribe(
				allDetail => {
				this.selectedRecordNameId = masterRecord.AnimalName + "/" + masterRecord.AnimalID;
				this.detailsService.getFeedingLineItemDetails(this.selectedRecord).subscribe(
					details => {
		  				this.feedingLineItemDetails = details;
						this.loadFeedingDetailList(allDetail);
				});
			})
		}
	}

	getShedRecords(){
		if(this.selectedRecord != 0){
			let masterRecord = this.masterRecords.find(record => record.Id == this.selectedRecord);

			this.selectedRecordNameId = masterRecord.AnimalName + "/" + masterRecord.AnimalID;
			this.detailsService.getShedLineItemDetails(this.selectedRecord).subscribe(
				details => {
	  				this.shedLineItemDetails = details;
					this.loadShedDetailList();
			});
		}
	}

	getGrowthRecords(){
		if(this.selectedRecord != 0){
			let masterRecord = this.masterRecords.find(record => record.Id == this.selectedRecord);

			this.selectedRecordNameId = masterRecord.AnimalName + "/" + masterRecord.AnimalID;
			this.detailsService.getGrowthLineItemDetails(this.selectedRecord).subscribe(
				details => {
	  				this.growthLineItemDetails = details;
					this.loadGrowthDetailList();
			});
		}
	}

	getHealthRecords(){
		if(this.selectedRecord != 0){
			let masterRecord = this.masterRecords.find(record => record.Id == this.selectedRecord);

			this.selectedRecordNameId = masterRecord.AnimalName + "/" + masterRecord.AnimalID;
			this.detailsService.getHealthLineItemDetails(this.selectedRecord).subscribe(
				details => {
	  				this.healthLineItemDetails = details;
	  				this.loadHealthDetailList();
			});
		}
	}

	getDefecationRecords(){
		if(this.selectedRecord != 0){
			let masterRecord = this.masterRecords.find(record => record.Id == this.selectedRecord);

			this.selectedRecordNameId = masterRecord.AnimalName + "/" + masterRecord.AnimalID;
			this.detailsService.getFecalLineItemDetails(this.selectedRecord).subscribe(
				details => {
	  				this.defecationLineItemDetails = details;
					this.loadDefecationDetailList();
			});
		}
	}

	exportFeedingDetails(){
		let options: any = { 
			    fieldSeparator: ',',
			    quoteStrings: '"',
			    decimalseparator: '.',
			    showLabels: true, 
			    showTitle: true,
			    title: 'Feed Details - '+ this.selectedRecordNameId,
			    useBom: true,
			    noDownload: false,
			    headers: ['Feed Type','Feed Size','Quantity', 'Outcome', 'Additional Notes' ],
			    nullToEmptyString: true,
			  };
		new Angular5Csv(this.listFeedDetail, 'FeedDetail', options);
	}

	exportShedDetails(){
		
		let options: any = { 
			    fieldSeparator: ',',
			    quoteStrings: '"',
			    decimalseparator: '.',
			    showLabels: true, 
			    showTitle: true,
			    title: 'Shed Details - '+ this.selectedRecordNameId,
			    useBom: true,
			    noDownload: false,
			    headers: ['Display','SoakRequired','AdditionalNotes' ],
			    nullToEmptyString: true,
			  };
		new Angular5Csv(this.listShedDetail, 'ShedDetail', options);
	}

	exportGrowthDetails(){
		let options: any = { 
			    fieldSeparator: ',',
			    quoteStrings: '"',
			    decimalseparator: '.',
			    showLabels: true, 
			    showTitle: true,
			    title: 'Growth Details - '+ this.selectedRecordNameId,
			    useBom: true,
			    noDownload: false,
			    headers: ['Weight','Length','AdditionalNotes'],
			    nullToEmptyString: true,
			  };
		new Angular5Csv(this.listGrowthDetail, 'GrowthDetail', options);
	}

	exportHealthDetails(){		
		let options: any = { 
			    fieldSeparator: ',',
			    quoteStrings: '"',
			    decimalseparator: '.',
			    showLabels: true, 
			    showTitle: true,
			    title: 'Health Details - '+ this.selectedRecordNameId,
			    useBom: true,
			    noDownload: false,
			    headers: ['IncidentType','IncidentResultNotes','Medication','MedicationDose','AdditionalNotes'],
			    nullToEmptyString: true,
			  };
		new Angular5Csv(this.listHealthDetail, 'HealthDetail', options);
	}

	exportFecalDetails(){
		let options: any = { 
			    fieldSeparator: ',',
			    quoteStrings: '"',
			    decimalseparator: '.',
			    showLabels: true, 
			    showTitle: true,
			    title: 'Fecal Details - '+ this.selectedRecordNameId,
			    useBom: true,
			    noDownload: false,
			    headers: ['Appearance','Additional Notes' ],
			    nullToEmptyString: true,
			  };
		new Angular5Csv(this.listFecalDetail, 'FecalDetail', options);
	}


	openInventoryDetails(id: number){
		//Open Individual Inventory Page
	}
}



// WEBPACK FOOTER //
// ./src/app/inventory-manager/view-inventory/view-inventory.component.ts